// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  Pluralizer
// -----------------------------------------------------------
const Pluralizer = ({ count, singular, plural }) => {
  const word = (() => {
    if (count === 1) return singular;

    return plural || `${singular}s`;
  })();

  return (
    <span data-test-id="display-quantity">
      {count} {word}
    </span>
  );
};

export default Pluralizer;
